import React, { memo } from 'react'
import { useInView } from 'react-intersection-observer'

import GameBoxFallback from './Fallback'
import GameBoxWithData from './GameBoxWithData'
import { GameBoxProps } from './types'

function LazyGameBox(props: GameBoxProps) {
  const { ref, inView } = useInView({ triggerOnce: true })

  if (!inView) {
    return <GameBoxFallback innerRef={ref} />
  }

  return <GameBoxWithData {...props} />
}

export default memo(LazyGameBox)
